import React, { useState, MouseEvent } from "react"

import {
  Box,
  Button,
  IconButton,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material"
import { ThemeProvider } from "@mui/material"

import ArrowDown from "../../../assets/icons/ArrowDown.svg"
import { customTheme } from "./Atom"
import DoneIcon from "@mui/icons-material/Done"

type Props = {}

const RowMenu = (props: any) => {
  const { handleApplyToRow, handleClearRow, valueToApply, row } = props

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <ThemeProvider theme={customTheme}>
      <Box>
        <IconButton
          sx={{
            opacity: valueToApply == "Not Available" ? 0.5 : 1,
            // cursor: selectedMetricGoalsTab?.isPublished ? "not-allowed" : valueToApply == "Not Available" ? "not-allowed" : "pointer"
          }}
          id="basic-button"
          aria-controls={open ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
          disabled={valueToApply == "Not Available" ? true : false}
        >
          <img src={ArrowDown} alt="" />
        </IconButton>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
          sx={{ display: "flex" }}
        >
          <MenuItem
            onClick={() => {
              handleApplyToRow(row, valueToApply)
              handleClose()
            }}
          >
            <Button
              fullWidth
              sx={{
                backgroundColor: "#3366D61A",
                margin: "0",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <DoneIcon
                sx={{ marginRight: "10px", color: "#42B2A0" }}
                fontSize="inherit"
              />
              <Typography fontSize={"14px"} fontWeight={500} color={"#000000"}>
                Apply to year
              </Typography>
            </Button>
          </MenuItem>
          <MenuItem
            onClick={() => {
              handleClearRow(row)
              handleClose()
            }}
          >
            <Button fullWidth sx={{ color: "#707070" }}>
              <Typography
                sx={{}}
                fontSize={"14px"}
                fontWeight={500}
                color={"#000000"}
              >
                Reset year
              </Typography>
            </Button>
          </MenuItem>
        </Menu>
      </Box>
    </ThemeProvider>
  )
}

export default RowMenu
